import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom'

import MembershipFormContext from '../../context/membership'

import { getSS, setSS } from '../../helpers'
import { saveMembership } from '../../api'

interface CreditCardDetailsProps {
  [key: string]: any
}

const CreditCardDetails: React.FC<CreditCardDetailsProps> = (props:any) => {

  const navigate = useNavigate()
  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const [ showCvv, setShowCvv ] = useState(false)
  const [ showCardError, setShowCardError ] = useState(false)
  const [ showCvvError, setShowCvvError ] = useState(false)
  const [ showExpDateError, setShowExpDateError ] = useState(false)
  const [ authenticationError, setAuthenticationError ] = useState(false)
  const url = membership_form.private_form ? 'private/' + props.url : props.url

  let membership = getSS('membership')

  useEffect(() => {

    // braintree
    const submit: any = document.querySelector('#m-make-payment');

    let threeDSecure: any;

    // membershipForm.hideLoading();

    (window as any).braintree.client.create({
      authorization: membership.payment_token
    }, function(err: any, clientInstance: any) {
        if (err) {
            console.error(err);
            return;
        }
      // If fraud tools enabled capture device data
      if ((window as any).KEW.globals.pay_enable_fraud_tools === 'true') {
        (window as any).braintree.dataCollector.create({
            client: clientInstance,
            kount: true
          }, function(err: any, dataCollectorInstance: any) {
          if (err) {
              console.error(err);
              return;
          }
          // At this point, you should access the dataCollectorInstance.deviceData value and provide it
          // to your server, e.g. by injecting it into your form as a hidden input.
          if (dataCollectorInstance.deviceData) {
              // We need to escape quotes in the device data to prevent problems marshalling this to JSON later
              // (the device data is JSON itself)
            membership.payment_device_data = dataCollectorInstance.deviceData.replace(/"/g, '\\"');
            setSS('membership', membership)
          }
        });
      }

      (window as any).braintree.threeDSecure.create({
        version: 2, // Will use 3DS 2 whenever possible
        client: clientInstance
        }, function (threeDSecureErr: any, threeDSecureInstance: any) {
        if (threeDSecureErr) {
            // Handle error in 3D Secure component creation
            console.log(threeDSecureErr)
            return;
        }
        threeDSecure = threeDSecureInstance;
      });

      createHostedFields(clientInstance);

    });

    var fields = {
      number: { selector: '#card-number' },
      expirationDate: { selector: '#expiration-date', placeholder: 'MM/YY' },
      cvv: { selector: '#cvv' }
    }

    // if (showPostcode) {
    //   fields.postalCode = {
    //     selector: '#postal-code'
    //   };
    // }

    function createHostedFields(clientInstance: any) {
      (window as any).braintree.hostedFields.create({
        client: clientInstance,
        styles: {
          'input': {
            'font-size': '16px',
            'font-family': 'roboto, verdana, sans-serif',
            'font-weight': 'lighter',
            'color': 'black'
          },
          '#credit-card-number::-ms-clear': {
            'color': 'white'
          },
          '#credit-card-number::-ms-reveal': {
            'color': 'white'
          },
          '#expiration-date::-ms-clear': {
            'color': 'white'
          },
          '#expiration-date::-ms-reveal': {
            'color': 'white'
          },
          '#expiration-year::-ms-clear': {
            'color': 'white'
          },
          '#expiration-year::-ms-reveal': {
            'color': 'white'
          },
          '.cvv::-ms-clear': {
            'color': 'white'
          },
          '.cvv::-ms-reveal': {
            'color': 'white'
          },
          ':focus': {
            'color': 'black'
          },
          '.valid': {
            'color': 'black'
          },
          '.invalid': {
            'color': '#BB131A'
          },
          '::-webkit-input-placeholder': {
            'color': '#757575'
          },
          ':-moz-placeholder': {
            'color': '#757575'
          },
          '::-moz-placeholder': {
            'color': '#757575'
          },
          ':-ms-input-placeholder': {
            'color': '#757575'
          },
        },
        fields: fields
      }, function (err: any, hostedFieldsInstance: any) {
        if (err) {
          console.error(err);
          return;
        }

        // hostedFieldsInstance.focus('number');

        hostedFieldsInstance.on('validityChange', function (event: any) {
          // Check if fields are valid and remove validation messages
          var field = event.emittedBy;
          var fields = event.fields;

          if (field === 'number' && fields.number.isValid === true) {
            setShowCardError(false);
          }
          if (field === 'number' && fields.number.isValid === false) {
            setShowCardError(true);
          }
          if (field === 'cvv' && fields.cvv.isValid === true) {
            setShowCvvError(false);
          }
          if (field === 'cvv' && fields.cvv.isValid === false) {
            setShowCvvError(true);
          }
          if (field === 'expirationDate' && fields.expirationDate.isValid === true) {
            setShowExpDateError(false);
          }
          if (field === 'expirationDate' && fields.expirationDate.isValid === false) {
            setShowExpDateError(true);
          }
          // if (field === 'postalCode' && fields.postalCode.isValid === true) {
          //   setShowPostcodeError(false);
          // }
          // if (field === 'postalCode' && fields.postalCode.isValid === false) {
          //   setShowPostcodeError(true);
          // }
        });

        hostedFieldsInstance.on('empty', function (event: any) {
          (window as any).document.getElementById('card-number').className = "";
        });

        hostedFieldsInstance.on('cardTypeChange', function (event: any) {
          // Change card bg depending on card type
          if (event.cards.length === 1) {
            //    document.getElementById('card-number').className = "";
            (window as any).document.getElementById('card-number').classList.add(event.cards[0].type);

            // Change the CVV length for AmericanExpress cards
            if (event.cards[0].code.size === 4) {
              hostedFieldsInstance.setPlaceholder('cvv', '1234');
            }
          } else {
            hostedFieldsInstance.setPlaceholder('cvv', '123');
          }
        });

        hostedFieldsInstance.on('blur', function (event: any) {
          var hosted = document.getElementsByClassName("hosted-field");
          for (var i = 0; i < hosted.length; i++) {
            hosted[i].classList.remove("selected");
          }
        });

        hostedFieldsInstance.on('focus', function (event: any) {
          setAuthenticationError(false)
          let parentElem: any = ''
          switch (event.emittedBy) {
            case 'number':
              parentElem = document.getElementById('card-number')
              break;
            case 'expirationDate':
              parentElem = document.getElementById('expiration-date')
              break;
            case 'cvv':
              parentElem = document.getElementById('cvv')
              break;
            default:
              break;
          }
          parentElem.classList.add("selected");
        });

        submit.addEventListener('click', function (event: any) {
          event.preventDefault();

          // show loading
          (window as any).scrollTo(0, 0);
          membershipForm.showLoading()
          // (window as any).document.getElementById('next-button-step2-single').attr('disabled', 'disabled');

          setShowCardError(false);
          setShowCvvError(false);
          setShowExpDateError(false);
          // setShowPostcodeError(false);

          hostedFieldsInstance.tokenize(function (err: any, payload: any) {
            if (err) {
              // console.error(err);

              // hide loading
              // (document as any).getElementById('next-button-step2-single').removeAttr('disabled');

              // show validation fields
              if (err.details !== undefined) {
                console.log(err);
                membershipForm.hideLoading()

                err.details.invalidFieldKeys.forEach(function (value: any, key: any) {
                  if (value === 'number') {
                    setShowCardError(true);
                  }
                  if (value === 'cvv') {
                    setShowCvvError(true);
                  }
                  if (value === 'expirationDate') {
                    setShowExpDateError(true);
                  }
                  // if (value === 'postalCode') {
                  //   setShowPostcodeError(true);
                  // }
                })

              } else {
                console.log(err);
                setShowCardError(true);
                setShowCvvError(true);
                setShowExpDateError(true);
                membershipForm.hideLoading()
                // setShowPostcodeError(true);
                setTimeout(function () {
                  var list:any = document.getElementsByClassName('error');
                  list[0]["parentNode"].scrollIntoView();
                }, 100);
              }
              return;
            }


            function truncate(length: any, string: any) {
              if (string) {
                return string.substring(0, length)
              }
            }

            threeDSecure.verifyCard({
              amount: membership.amount,
              nonce: payload.nonce,
              bin: payload.details.bin,
              billingAddress: {
                givenName: truncate(50, membership.first_name),
                surname: truncate(50, membership.last_name),
                phoneNumber: membership.phone,
                streetAddress: truncate(50, membership.line1),
                extendedAddress: truncate(50, membership.line2), // When available
                locality: truncate(50, membership.town),
                region: truncate(50, membership.region),
                postalCode: truncate(9, membership.postal_code),
                countryCodeAlpha2: membership.country
              },
              additionalInformation: {
                workPhoneNumber: '',
                shippingGivenName: truncate(50, membership.first_name),
                shippingSurname: truncate(50, membership.last_name),
                shippingPhone: membership.phone,
                shippingAddress: {
                  streetAddress: truncate(50, membership.line1),
                  extendedAddress: truncate(50, membership.line2), // When available
                  locality: truncate(50, membership.town),
                  region: truncate(50, membership.region),
                  postalCode: truncate(9, membership.postal_code),
                  countryCodeAlpha2: membership.country
                }
              },
              onLookupComplete: function (data: any, next: any) {
                // use `data` here, then call `next()`
                next()
              }
            }, async function (err: any, verification: any) {
              if (err) {
                console.log('verification error:', err);
                // hide loading
                setAuthenticationError(true)
                membershipForm.hideLoading()
                return;
              }
              // NOTE: payment method nonces expire after 3 hours
              membership.payment_method_token_or_nonce = verification.nonce;

              // Update the donation record attempting to process the payment
              membership.process_payment = true;
              if (membership.optins_giftaid) {
                membership.giftaid_amount = +(membership.amount * 0.25).toFixed(2);
              }

              const savedMembership = await saveMembership(membership)
              console.log(savedMembership);

              if (savedMembership?.status === 200) {
                setSS('membership', savedMembership.data);
                membershipForm.hideLoading()
                navigate(`/membership/${url}/thanks`);
              } else {
                setSS('api-error', savedMembership.headers['api-error'])
                membershipForm.hideLoading()
                navigate(`/membership/${url}/failed`)
              }

            });
          });
        }, false);
      });
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      { membership &&
        <div className="row box card-details">
          <div className="large-12 columns">
            <div className="form-item">
              <h2>Your payment details</h2>
              <label className="donation-amount">Membership{membership_form.form_type === 'upgrade' &&<span> upgrade</span>} fee: £{(membership.amount).toFixed(2)}</label>
            </div>
          </div>
          <div className="large-12 columns">
            <div className="row">
              <div className="medium-6 columns">
                <div className="form-item">
                  <label htmlFor="card-number" className="form">Card number</label>
                  <div id="card-number" className="hosted-field"></div>
                  { showCardError &&
                    <span className="error">Please enter a valid card number</span>
                  }
                </div>
              </div>

              <div className="medium-3 columns">
                <div className="form-item">
                  <label htmlFor="expiration-date" className="form">Expiry date</label>
                  <div id="expiration-date" className="hosted-field"></div>
                  { showExpDateError &&
                    <span className="error">Please enter a valid expiry date</span>
                  }
                </div>
              </div>

              <div className="medium-3 columns">
                <div className="form-item">
                  <label htmlFor="cvv" className="form">CVV</label>
                  <div className="cvv-wrapper">
                    <div id="cvv" className="hosted-field"></div>
                    <button type="button" className="cvv-help" aria-label="Show cvv information" onClick={() => setShowCvv(!showCvv)} aria-expanded={showCvv} aria-controls="cvv-info">?</button>
                    { showCvvError &&
                      <span className="error">Please enter a valid card security code</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          { authenticationError &&
            <div className="large-12 columns">
              <span className="error">Sorry - we were unable to authenticate your payment. Please try again using a different card, or go back and change your payment method to PayPal.</span>
            </div>
          }
          <div className="large-12 columns cvv" aria-live="polite">
            { showCvv &&
              <div className="inner" id="cvv-info">
                <p>You'll find your CVV code either:</p>
                <ul className="list">
                  <li>on the back of your credit/debit card (it’s the last 3 digits on the right side of the signature strip)</li>
                  <li>or (for Amex only), it’s the 4-digit number on the front right of the card, just above the card number</li>
                </ul>
              </div>
            }
          </div>
        </div>
      }
    </>
  );
};

export default CreditCardDetails;